import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioButtonComponent } from '@immomio/ui/button';

@Component({
  standalone: true,
  selector: 'rs-web-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImmomioButtonComponent, TranslateModule],
})
export class ConfirmationDialogComponent {
  @Input() message: string;
  @Input() acknowledge = false;
  @Input() innerHTML = false;
  @Input() titleMessage: string;
  @Input() okButtonMessage = 'general.accept';
  @Input() cancelButtonMessage = 'general.cancel';
  @Input() titleValue = null;
  @Input() messageValue = null;

  constructor(private ngbActiveModal: NgbActiveModal) {}

  okAction() {
    this.ngbActiveModal.close();
  }

  cancelAction() {
    this.ngbActiveModal.dismiss();
  }
}
